import type { IsoPoint } from '@modo-vivo/contracts';

export const ISO_TILE_WIDTH = 64;
export const ISO_TILE_HEIGHT = 32;

export function isoToScreen(point: IsoPoint, originX = 0, originY = 0): { x: number; y: number } {
  const x = (point.x - point.y) * (ISO_TILE_WIDTH / 2) + originX;
  const y = (point.x + point.y) * (ISO_TILE_HEIGHT / 2) + originY;
  return { x, y };
}

export function screenToIso(screenX: number, screenY: number, originX = 0, originY = 0): IsoPoint {
  const sx = screenX - originX;
  const sy = screenY - originY;
  const x = (sx / (ISO_TILE_WIDTH / 2) + sy / (ISO_TILE_HEIGHT / 2)) / 2;
  const y = (sy / (ISO_TILE_HEIGHT / 2) - sx / (ISO_TILE_WIDTH / 2)) / 2;
  return { x, y };
}

export function depthFromIso(point: IsoPoint): number {
  return point.x + point.y;
}

export function distanceIso(a: IsoPoint, b: IsoPoint): number {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return Math.hypot(dx, dy);
}
